/**
 * Format the given date.
 */
Vue.filter("date", value => {
    return moment.utc(value).local().format("D MMM YYYY");
});

Vue.filter("dateNumeric", value => {
    return moment.utc(value).local().format("DD-MM-YYYY");
});

Vue.filter("dateShort", value => {
    return moment.utc(value).local().format("D MMM \'YY");
});

/**
 * Format the given date as a timestamp.
 */
Vue.filter("datetime", value => {
    return moment.utc(value).local().format("D MMM YYYY HH:mm");
});

/**
 * Display only the time part of a timestime.
 */
Vue.filter("timeonly", value => {
    return moment.utc(value).local().format("HH:mm");
});

/**
 * Format the given date as a timestamp with seconds added.
 */
Vue.filter("datetimeWithSeconds", value => {
    return moment.utc(value).local().format("D MMM YYYY HH:mm:ss");
});

/**
 * Format the given date without converting to local timezone from utc. Used
 * for inspection date formatting.
 */
Vue.filter("localeUnawareDatetime", value => {
    return moment(value).format("D MMM YYYY HH:mm");
});

/**
 * Format the given date into a relative time.
 */
Vue.filter("relative", value => {
    return moment.utc(value).local().locale("en").fromNow();
});

Vue.filter("dateDayMonth", value => {
    return moment.utc(value).local().format("DD MMMM");
});

/**
 * Convert the first character to upper case.
 *
 * Source: https://github.com/vuejs/vue/blob/1.0/src/filters/index.js#L37
 */
Vue.filter("capitalize", value => {
    if (!value && value !== 0) {
        return "";
    }

    return value.toString().charAt(0).toUpperCase()
        + value.slice(1);
});

Vue.filter("titlecase", value => {

    return _.startCase(value);

});

Vue.filter("money", value => {

    if (isNaN(value)) {
        return 0;
    }

    // can also replace '$& ' with '$&, ' to get the format 25,000.85
    return parseFloat(value).toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$& ");
});

Vue.filter("noDecimals", value => {

    if (value == null) {
        return 0;
    }

    if (_.isString(value)) {
        return Math.round(parseFloat(value)).toFixed(0);
    }

    return value.toFixed(2);

});

Vue.filter("pluralizeOnlyS", (value, length) => {
    if (length !== 1) {
        return value + "s";
    } else {
        return value;
    }
});
